<template>
  <div>
    <div class="font-size__large font-weight__bold margin-top-10">Danh sách nhận văn bản:</div>

    <hashtag-common-soduyet-cxl
      :stepId="stepId"
      @selectTags="selectHashTag"
      @unSelectTags="unSelectHashTag"
    />

    <div class="flex-row flex__left margin-top-10 margin-bottom-10">
      <div class="flex-row flex__left width__200 margin-right-40">
        <div class="margin-right-10">Hiện mục đã chọn</div>
        <el-switch
          v-model="showChecked"
          @change="showCheckedChanged"
        />
      </div>
    </div>

    <div class="flex-col">
      <div v-if="isOpenSoDuyetTree" :class="orderForTreeDang">
        <so-duyet-tree
          title="Khối Đảng"
          :userDeptRoles="udrsForDang"
          ref="treeDang"
        />
      </div>

      <div v-if="isOpenSoDuyetTree" :class="orderForTreeChuyenMon">
        <so-duyet-tree
          title="Khối chuyên môn"
          :userDeptRoles="udrsForChuyenMon"
          ref="treeChuyenMon"
        />
      </div>

      <div v-if="isOpenSoDuyetTree" class="order_3">
        <so-duyet-tree
          title="Khối Công đoàn Tổng công ty"
          :userDeptRoles="udrsForCongDoan"
          ref="treeCongDoan"
        />
      </div>

      <div v-if="isOpenSoDuyetTree" class="order_4">
        <so-duyet-tree
          title="Khối Đoàn thanh niên Tổng công ty"
          :userDeptRoles="udrsForDoanThanhNien"
          ref="treeDoanThanhNien"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SoDuyetTree from "./so-duyet-tree"
import constants from "../../../constants";
import HashtagCommonSoduyetCxl from "./chuyenXuLy-hashtag-soduyet-cxl";
import userDeptRoleViewService from "../../../services/userDeptRoleViewService";

export default {
  name: 'so-duyet-tree-group',
  components: {
    SoDuyetTree,
    HashtagCommonSoduyetCxl
  },
  props: ['stepId'],

  data() {
    return {
      showChecked: false,
      udrsForDang: null,
      udrsForChuyenMon: null,
      udrsForCongDoan: null,
      udrsForDoanThanhNien: null,
      isOpenSoDuyetTree: false
    }
  },

  computed: {
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },

    isNhanhDang() {
      return (
        this.userDeptRole &&
        this.userDeptRole.deptPath.includes(`/${this.$store.getters.globalRoles}/${constants.DANG_UY_TCT_DEPT_CODE}`, 0)
      );
    },

    orderForTreeDang() {
      return {
        order_1: this.isNhanhDang,
        order_2: !this.isNhanhDang
      }
    },

    orderForTreeChuyenMon() {
      return {
        order_2: this.isNhanhDang,
        order_1: !this.isNhanhDang
      }
    }
  },

  created() {
    this.init();
  },

  methods: {
    async init() {
      let userDeptRoles = [];
      await userDeptRoleViewService.findAll({
        status: constants.STATUS_.ACTIVE,
        usersStatus: constants.STATUS_.ACTIVE,
        deptStatus: constants.STATUS_.ACTIVE
      })
      .then(res => userDeptRoles = res.data);

      this.udrsForDang = userDeptRoles.filter(item =>
        item.deptPath && item.deptPath.includes(`/${this.$store.getters.globalRoles}/${constants.DANG_UY_TCT_DEPT_CODE}`, 0)
      );

      this.udrsForChuyenMon = userDeptRoles.filter(item =>
        item.deptCode !== constants.DANG_UY_TCT_DEPT_CODE
        && item.deptCode !== constants.DEPARTMENT.DEPT_CODE.CONG_DOAN_TCT
        && item.deptCode !== constants.DEPARTMENT.DEPT_CODE.DOAN_THANH_NIEN_TCT
      );
      this.udrsForCongDoan = userDeptRoles.filter(item =>
        item.deptPath && item.deptPath.includes(`/${this.$store.getters.globalRoles}/${constants.DEPARTMENT.DEPT_CODE.CONG_DOAN_TCT}`, 0)
      );
      this.udrsForDoanThanhNien = userDeptRoles.filter(item =>
        item.deptPath && item.deptPath.includes(`/${this.$store.getters.globalRoles}/${constants.DEPARTMENT.DEPT_CODE.DOAN_THANH_NIEN_TCT}`, 0)
      );

      this.isOpenSoDuyetTree = true;
    },

    selectHashTag(event, hashtagProcessTypeSelect) {
      this.$refs.treeDang.selectHashTag(event, hashtagProcessTypeSelect);
      this.$refs.treeChuyenMon.selectHashTag(event, hashtagProcessTypeSelect);
      this.$refs.treeCongDoan.selectHashTag(event, hashtagProcessTypeSelect);
      this.$refs.treeDoanThanhNien.selectHashTag(event, hashtagProcessTypeSelect);
    },

    unSelectHashTag(event) {
      this.$refs.treeDang.unSelectHashTag(event);
      this.$refs.treeChuyenMon.unSelectHashTag(event);
      this.$refs.treeCongDoan.unSelectHashTag(event);
      this.$refs.treeDoanThanhNien.unSelectHashTag(event);
    },

    showCheckedChanged() {
      this.$refs.treeDang.filter.showChecked = this.showChecked;
      this.$refs.treeDang.searchTree();

      this.$refs.treeChuyenMon.filter.showChecked = this.showChecked;
      this.$refs.treeChuyenMon.searchTree();

      this.$refs.treeCongDoan.filter.showChecked = this.showChecked;
      this.$refs.treeCongDoan.searchTree();

      this.$refs.treeDoanThanhNien.filter.showChecked = this.showChecked;
      this.$refs.treeDoanThanhNien.searchTree();
    },

    getSelectedHandlersData() {
      const dataForDang = this.$refs.treeDang.getSelectedHandlersData();
      const dataForChuyenMon = this.$refs.treeChuyenMon.getSelectedHandlersData();
      const dataForCongDoan = this.$refs.treeCongDoan.getSelectedHandlersData();
      const dataForThanhNien = this.$refs.treeDoanThanhNien.getSelectedHandlersData();

      return [...dataForDang, ...dataForChuyenMon, ...dataForCongDoan, ...dataForThanhNien];
    }
  }
}
</script>
<style scoped>
/* Safari 6.1+ */
.order_1 {-webkit-order: 1;}
.order_2 {-webkit-order: 2;}
.order_3 {-webkit-order: 3;}
.order_4 {-webkit-order: 4;}

/* Standard syntax */
.order_1 {order: 1;}
.order_2 {order: 2;}
.order_3 {order: 3;}
.order_4 {order: 4;}
</style>



// WEBPACK FOOTER //
// src/views/doc-in/components/so-duyet-tree-group.vue